module.exports = __webpack_public_path__ + "static/The Final Curtain-6af233fab846f252bcc6bc0c89dab395.png";